import { render } from "./card.vue?vue&type=template&id=0b225b90"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b225b90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b225b90', __exports__)) {
    console.log('reload')
    api.reload('0b225b90', __exports__)
  }
  
  module.hot.accept("./card.vue?vue&type=template&id=0b225b90", () => {
    console.log('re-render')
    api.rerender('0b225b90', render)
  })

}


export default __exports__